import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import { h4, paragraphSmall, subtitle } from '@helpers/typography';
import styled, { css } from 'styled-components';
import { ContentType } from '../SectionWrapper/SectionWrapper';
export const FiltersFormColumns = css `
  container-type: inline-size;
  grid-column: 1 / -1;

  @media ${from(Device.Tablet)} {
    grid-column: 2 / -2;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 3 / -3;
  }
`;
export const FiltersFormWrapperStyles = css `
  ${FiltersFormColumns};

  --radius: ${fluid(12, 20)};
  --fgColour: ${brand.global.white};

  &[data-type=${ContentType.Default}] {
    --bgColour: ${brand.green.gradient};
    --direction: 0deg;
  }

  &[data-type=${ContentType.Intermediaries}] {
    --bgColour: ${brand.green.light};
    --fgColour: ${brand.blue.navy};
  }

  &[data-type=${ContentType.Savings}] {
    --bgColour: ${brand.blue.gradient};
  }

  container-name: filters-form-container;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 0;
`;
const Container = styled.div `
  ${FiltersFormWrapperStyles};
`;
const ContentWrapper = styled.div `
  grid-column: 1 / -1;
  background: var(--bgColour);
  color: var(--fgColour);
  border-radius: var(--radius) var(--radius) 0 0;
  padding: ${fluid(24, 48)} ${fluid(16, 24)} ${fluid(24, 48)} ${fluid(16, 28)};

  @container filters-form-container ${from(675)} {
    grid-column: span 3;
    border-radius: var(--radius) 0 0 0;
  }
`;
const Subtitle = styled.p `
  ${subtitle};

  --subtitleColour: var(--fgColour);

  margin: 0;
`;
const Title = styled.h2 `
  ${h4};

  margin: 0;
`;
const Introduction = styled.p `
  ${paragraphSmall};

  margin: ${fluid(14, 20)} 0 0;
`;
export const FormWrapperStyles = css `
  grid-column: 1 / -1;
  background-color: ${brand.global.beige};
  color: ${brand.global.black};
  border-radius: 0 0 var(--radius) 0;
  padding: ${fluid(24, 48)} ${fluid(16, 20)};

  @container filters-form-container ${from(675)} {
    grid-column: span 5;
    border-radius: 0 var(--radius) var(--radius) 0;
  }
`;
const FormWrapper = styled.div `
  ${FormWrapperStyles};
`;
const FiltersFormContainerStyles = {
    Container,
    ContentWrapper,
    FormWrapper,
    Introduction,
    Subtitle,
    Title,
};
export default FiltersFormContainerStyles;
